import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndConditions } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-taxi-fare-rules-modal',
  templateUrl: './gmt-taxi-fare-rules-modal.html',
  styleUrls: ['./gmt-taxi-fare-rules-modal.scss'],
  standalone: false
})
export class GmtTaxiModalFareRulesComponent implements OnInit {
  termsAndCond: TermsAndConditions[] = [];
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}
}

LightningModalTypes.GmtTaxiModalFareRulesComponent.component = GmtTaxiModalFareRulesComponent;
